<template>
    <component :is="way" v-bind="$props" v-on="$listeners" />
</template>
<script>

    import PROCESS_NAMES from '@/process/names';
    import CandidateActionsDefault from './default.vue';
    const CandidateActionsMarsAb = () =>
        import(/* webpackChunkName: "candidate-actions-mars-ab" */'@/process/mars-ab/common/components/responses/candidate-actions/default');
    const CandidateActionsSportmaster = () =>
        import(/* webpackChunkName: "candidate-actions-sportmaster" */'@/process/sportmaster/components/response/candidate-actions/CandidateActionsSportmaster');

    export default {
        name: 'candidate-actions',
        props: {
            response: Object,
            fetch: Function,
            changeSendMessageDisplay: Function,
            changeLinkShareDisplay: Function
        },
        components: {
            CandidateActionsDefault,
            CandidateActionsMarsAb,
            CandidateActionsSportmaster
        },
        computed: {
            way () {
                let way = "candidate-actions";
                const process = this.$store.getters["response/process"];
                console.log('process', process);
                if (
                    process === PROCESS_NAMES.MARS_AB ||
                    process === PROCESS_NAMES.SPORTMASTER
                ) {
                    return `${way}-${process}`;
                } else {
                    return `${way}-default`;
                }
            }
        }
    }
</script>
